// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6543":"css/admin-app.6922","9171":"css/app.6922"}[chunkId] + ".css";
};